module.exports = __webpack_public_path__ + "static/media/login-icon_orange.2773ebc9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForm/login-icon_orange.svg
// module id = 623
// module chunks = 0